<template>

  <div style="width: 100%;height: 100%;">
    <div v-if="privacyDialogStatus" style="width: 100%;height: 100%;background-color: #e4e4e4;display: flex;">
      <div style="width: 600px;height: 350px;background-color: white;border-radius: 20px;margin: auto;
        box-shadow: 1px 1px 3px 1px #888888;display: flex;flex-direction: column;">
        <h1 style="text-align: center;">账号隐私通知</h1>
        <div style="width:100%;">
          <p style="display:block;width:500px;margin: auto;font-size: 20px;font-weight: 400;"
            v-html="accountNumInformStr">
          </p>
          <p style="display:block;width:500px;margin: auto;">
            内容详情请参见最新的<span style="color: #347BFF;cursor: pointer;" @click="clickProtocol(1)">账号用户协议</span>、
            <span style="color: #347BFF;cursor: pointer;" @click="clickProtocol(2)">关于账号与隐私的声明</span>。
          </p>
          <div style="width:500px;margin: auto;padding-top: 30px;padding-bottom: 40px;">
            <el-checkbox v-model="popupFlag" @change="change"><span style="font-size: 16px;color:#292929;">以后不再弹出</span>
            </el-checkbox>
          </div>
        </div>
        <div style="width:100%;display: flex;flex-direction: row;justify-content: space-around;">
          <div>
            <button style="width:200px;height:50px;border: 0;font-size: 16px;color: #347BFF;cursor: pointer;"
              @click="cancel()">取消</button>
          </div>
          <div>
            <button style="width:200px;height:50px;border: 0;font-size: 16px;color: #347BFF;cursor: pointer;"
              @click="agree()">同意</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="spreader_index" style="width:100%;">
      <div style="width:100%;height:64px;margin: auto;background: #347BFF;">
        <div
          style="width:1400px;height:64px;margin: auto;display: flex;flex-direction: row;justify-content: space-between;">
          <div
            style="width:300px;height:64px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
            <img width="164px" height="30px" src="../../assets/spreader/uoofox.png" style="margin-left: 16px;" />
            <div style="width:110px;height:30px;margin-left: 12px;">
              <p
                style="font-size: 18px;font-family: Microsoft YaHei;color: #FFFFFF;font-weight: 400;margin: 0;padding: 0;">
                推广者平台</p>
              <p
                style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;opacity: 0.22;font-weight: 400;margin: 0;padding: 0;">
                Promoter Platform</p>
            </div>
          </div>
          <div
            style="width:300px;height:64px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
            <p
              style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;margin: 0;padding: 0;">
              账户余额</p>
            <p
              style="font-size: 20px;font-family: Microsoft YaHei;font-weight: bold;color: #FFFFFF;margin: 0 0 0 15px;padding: 0;">
              {{ userInfo.getBalance }}</p>
            <div class="spreader_index1"
              style="height:100%;cursor: pointer;margin-left: 25px;position: relative;display: flex;align-items: center;justify-content: center;flex-direction: row;">
              <div style="display: flex;align-items: center;justify-content: center;">
                <img width="40px" height="40px" :src="headPicUrl" />
                <img width="13px" height="8px" src="../../assets/spreader/head_down.png" style="margin-left: 14px" />
              </div>
              <ul class="spreader_index2" style="width:140px;
                background: #FFFFFF;box-shadow: 0px 2px 8px 0px rgba(0, 15, 58, 0.12);
                margin: 0;padding: 0;list-style-type: none;position: absolute;left: -70px;top:60px;">
                <li
                  style="width:100%;height:46px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
                  <img width="20px" height="20px" src="../../assets/spreader/geren.png" />
                  <router-link to="/spreader/personalData" style="margin:0 0 0 10px;padding:0;font-size: 16px;
                    font-family: Microsoft YaHei;font-weight: 400;
                    color: #595959;text-decoration: none;" exact>个人资料</router-link>
                </li>
                <li
                  style="width:100%;height:46px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
                  <img width="20px" height="20px" src="../../assets/spreader/pwd.png" />
                  <p style="margin:0 0 0 10px;padding:0;font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #595959;" @click="updatePwdDialogFlag = true">修改密码</p>
                </li>
                <li
                  style="width:100%;height:46px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
                  <img width="20px" height="20px" src="../../assets/spreader/lgout.png" />
                  <p style="margin:0 0 0 10px;padding:0;font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #E74A4A;" @click="logoutDialogFlag = true">退出登录</p>
                </li>
                <li
                  style="width:100%;height:46px;display: flex;align-items: center;justify-content: center;flex-direction: row;">
                  <img width="20px" height="20px" src="../../assets/help.png" />
                  <p style="margin:0 0 0 10px;padding:0;font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #595959;" @click="help">帮助说明</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div style="width:100%;background: #F0F1F7;">
        <router-view @updateGetBalance="updateGetBalance" @updateHeadPic="updateHeadPic" @getInfo="getInfo"
          :userInfo="userInfo" :headPicUrl="headPicUrl">
        </router-view>
      </div>
      <el-dialog :visible.sync="updatePwdDialogFlag" top="30vh" width="460px" center>
        <p style="font-size: 20px;margin: 0;padding: 0 0 40px 0;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #292929;">修改密码</p>
        <el-input type="text" v-model="updatePwdForm.tel" placeholder="手机号"></el-input>
        <div style="display:flex;align-items: center;justify-content:space-between;padding-top: 20px;">
          <div style="width:288px;">
            <el-input type="text" v-model="updatePwdForm.code" placeholder="验证码"></el-input>
          </div>
          <el-button type="success" @click="getTelCode()">{{ codeButtonStr }}</el-button>
        </div>
        <el-input type="password" style="padding-top: 20px;" v-model="updatePwdForm.pwd" placeholder="新密码（6-16位长度）">
        </el-input>
        <el-input type="password" style="padding-top: 20px;" v-model="updatePwdForm.againPwd" placeholder="重复输入新密码">
        </el-input>
        <el-button type="primary" style="width:100%;font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;margin-top: 50px;" @click="clickeUpdatePwd">修改</el-button>
      </el-dialog>
      <el-dialog top="40vh" width="360px" :visible.sync="logoutDialogFlag" center>
        <p style="font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #292929;text-align: center;">确定退出登录吗？</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="logout()">确 定</el-button>
          <el-button @click="logoutDialogFlag = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="spreaderIndex1">
      <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/"
          target="_blank">粤ICP备2022061985号</a></p>
    </div>
  </div>
</template>

<script>
import { getHeadPic } from '@/utils/spreaderUtils'
import { getConfigs, getConfig } from '@/api/spreader/config';
import { getTelCode, getinfo, updatepwd } from '@/api/spreader/user';

export default {
  name: "spreader_index",
  components: {
  },
  created() {
    let pf = localStorage.getItem("popupFlag");
    let pf2 = sessionStorage.getItem("showFlag");
    if (pf2 == "false") {
      this.privacyDialogStatus = false;
    } else {
      this.privacyDialogStatus = (pf == "false" ? false : true);
    }
    console.log(this.privacyDialogStatus)
    let userInfo = sessionStorage.getItem("userInfo");
    if (userInfo == undefined || userInfo == null) {
      this.$router.push('/spreader/login');
    }
    this.codeButtonStr = '获取验证码';
    this.isGet = false;
    this.codeTime = 60;
    this.getInfo();
  },
  destroyed: function () {
  },
  mounted: function () {
    this.getAccountNumInformStr();
  },
  methods: {
    clickProtocol(value) {
      // console.log(value);
      if (value == 1) {
        window.open('https://www.ioofox.com/protocol', "_blank");
      }
      if (value == 2) {
        window.open('https://www.ioofox.com/privacyPolicy', "_blank");
      }
    },
    help() {
      //https://www.ioofox.com/download/help.webp
      window.open('https://www.ioofox.com/download/help.webp', "_blank");
    },
    getInfo() {
      return new Promise((resolve, reject) => {
        getinfo().then(res => {
          if (res.status == 200) {
            this.userInfo = res.data;
            this.headPicUrl = getHeadPic(this.$sip, this.userInfo.headPic);
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    updateGetBalance(getBalance) {
      this.userInfo.getBalance = getBalance;
    },
    updateHeadPic(headPic) {
      this.userInfo.headPic = headPic;
      this.headPicUrl = getHeadPic(this.$sip, headPic);
    },
    clickeUpdatePwd() {
      return new Promise((resolve, reject) => {
        updatepwd(this.updatePwdForm).then(res => {
          if (res.status == 200) {
            sessionStorage.removeItem("userInfo");
            this.updatePwdDialogFlag = false;
            this.$message('修改密码成功');
            this.$router.push('/spreader/login');
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    logout() {
      sessionStorage.removeItem("userInfo");
      this.logoutDialogFlag = false;
      this.$router.push('/spreader/login');
    },
    getTelCode() {
      if (this.updatePwdForm.tel == '') {
        this.$message('手机不能为空');
        return;
      }
      if (this.isGet == false) {
        let data = {
          tel: this.updatePwdForm.tel
        }
        new Promise((resolve, reject) => {
          getTelCode(data).then(res => {
            if (res.status == 200) {
              this.isGet = true
              this.telCodeInterval = setInterval(() => {
                if (this.codeTime == 0) {
                  this.isGet = false;
                  this.codeTime = 60;
                  this.codeButtonStr = '获取验证码';
                  clearInterval(this.telCodeInterval);
                } else {
                  this.codeTime = this.codeTime - 1;
                  this.codeButtonStr = this.codeTime + '重新发送';
                }
              }, 1000);
            } else {
              this.$message(res.message);
            }
          })
        })
      } else {
      }
    },
    //获取账号隐私通知字符串
    getAccountNumInformStr() {
      let data = {
        cid: 13
      }
      return new Promise((resolve, reject) => {
        getConfig(data).then(res => {
          if (res.status == 200) {
            this.accountNumInformStr = res.data.zh;
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    //帐号隐私通知取消按钮
    cancel() {
      //取消就返回登录界面
      localStorage.setItem("popupFlag", "true");
      this.$router.push('/spreader/login');
    },
    //帐号隐私通知同意按钮
    agree() {
      if (this.popupFlag == false) {
        sessionStorage.setItem("showFlag", "false");
        localStorage.setItem("popupFlag", "true");
      } else {
        localStorage.setItem("popupFlag", "false");
      }
      this.privacyDialogStatus = false;
    },
    change(value) {
      if (value == false) {
        sessionStorage.setItem("showFlag", "false");
      }
    }
  },
  data() {
    return {
      userInfo: {
        nickname: '',
        headPic: '',
        code: '',
        getBalance: '',
        gotBalance: '',
        inviterNum: '',
        idCardName: '',
        tel: '',
        idCardNum: '',
        bankCardName: '',
        bankCardNum: '',
      },
      headPicUrl: '',
      updatePwdForm: {
        tel: '',
        code: '',
        pwd: '',
        againPwd: '',
      },
      logoutDialogFlag: false,
      updatePwdDialogFlag: false,
      codeButtonStr: '',

      privacyDialogStatus: true,
      accountNumInformStr: '',
      popupFlag: false,

    };
  },
};
</script>

<style>
.spreader_index2 {
  display: none;
  z-index: 9999;
}

.spreader_index1:hover .spreader_index2 {
  display: block;
}

.spreader_index3 .el-dialog__header {
  display: none;
}

.spreader_index3 .el-dialog__body {
  padding: 0;
}

.el-dialog__wrapper .el-dialog {
  border-radius: 20px;
}

.spreaderIndex1 {
  background-color: black;
  width: 100%;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
}

.spreaderIndex1 a {
  text-decoration: none;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/index.vue